export const POSTHOG_TRACKING_EVENTS = {
  AO_DRAWER_OPEN: 'ao_drawer_open',
  ASSET_OPEN: 'asset_open',
  CHART_OPEN: 'chart_open',
  DASHBOARD_OPEN: 'dashboard_open',
  EVENTS_DRAWER_OPEN: 'events_drawer_open',
  INSIGHTS_DRAWER_OPEN: 'insights_drawer_open',
  INSIGHTS_OPEN: 'insights_open',
  MARKET_SUMMARY_OPEN: 'market_summary_open',
  NEWS_FILTER_SELECTED: 'news_filter_selected',
  NEWS_OPEN: 'news_open',
  QUERY_SENT: 'query_sent',
  SCREENER_CREATE: 'screener_create',
  SCREENER_OPEN: 'screener_open',
  SEARCH_OPEN: 'search_open',
  SEND_ALL_ASSETS: 'send_all_assets',
  THEME_OPEN: 'theme_open',
  TLI_DRAWER_OPEN: 'tli_drawer_open',
  WATCHLIST_CREATE: 'watchlist_create',
  WATCHLIST_OPEN: 'watchlist_open',
  WATCHLIST_TAB_SELECTED: 'watchlist_tab_selected',
  EARNINGS_INSIGHT_DRAWER_OPEN: 'earnings_insight_drawer_open',
} as const;

export type PosthogTrackingEventName =
  typeof POSTHOG_TRACKING_EVENTS[keyof typeof POSTHOG_TRACKING_EVENTS];

export const POSTHOG_TRACKING_SOURCES = {
  ALFRED: 'alfred',
  CHART: 'chart',
  DASHBOARD_ALFRED: 'dashboard_alfred',
  DASHBOARD_CALENDAR: 'dashboard_calendar',
  DOCUMENT_SEARCH: 'document_search',
  DASHBOARD_TLI: 'dashboard_tli',
  DASHBOARD_WATCHLIST: 'dashboard_watchlist',
  DASHBOARD_WHATS_NEW: 'dashboard_whats_new',
  EVENTS: 'events',
  INSIGHTS: 'insights',
  LOGIN: 'login',
  NAVIGATION_BAR: 'nav',
  NEWS: 'news',
  SCENARIO: 'scenario',
  SCREENER: 'screener',
  SEARCH: 'search',
  STREAM: 'stream',
  THEME_OVERVIEW: 'theme_overview',
  TLI: 'tli',
  WATCHLIST: 'watchlist',
  ASSET_OVERVIEW: 'asset_overview',
  ASSET_OVERVIEW_DRAWER: 'asset_overview_drawer',
  INVENTORY_SIDEBAR: 'inventory_sidebar',
  EARNINGS_INSIGHT_DRAWER: 'earnings_insight_drawer',
  MARKET_SUMMARY_DRAWER: 'market_summary_drawer',
  EMAIL: 'email',
} as const;

export type PosthogTrackingSource =
  typeof POSTHOG_TRACKING_SOURCES[keyof typeof POSTHOG_TRACKING_SOURCES];
